"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageAction = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Integrations = require("../constants/Integrations");
var analyticsWeb = _interopRequireWildcard(require("./analytics-web"));
var _datadogLogger = _interopRequireDefault(require("../logger/datadogLogger"));
var _isDDsynthetics = _interopRequireDefault(require("../utils/isDDsynthetics"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Wrapper to use the pageActions
 *
 * Example usage
 * const action = pageAction(
 *     'dev',
 *     'userId',
 *     'rudderstackWriteKey',
 *     'rudderstackDataPlaneUrl',
 *     'appVersion',
 *     'teamId',
 *     'broadcastId',
 *     'eventId',
 *     'webinarId',
 *     'externalUserId',
 * );
 *
 * action('hostAddedSpeakerToStage', {speakerId: 419});
 *
 * @param environmentName
 * @param userId
 * @param rudderstackWriteKey
 * @param rudderstackDataPlaneUrl
 * @param appVersion
 * @param teamId
 * @param broadcastId
 * @param eventId
 * @param webinarId
 * @param externalUserId
 * @returns {function(*, *): *}
 */
var pageAction = exports.pageAction = function pageAction(environmentName, userId, rudderstackWriteKey, rudderstackDataPlaneUrl, appVersion, teamId, broadcastId, eventId, webinarId, externalUserId) {
  var _require = require('@rudderstack/analytics-js/bundled'),
    RudderAnalytics = _require.RudderAnalytics;
  var rudderanalytics = new RudderAnalytics();
  var isDDSynthetics = (0, _isDDsynthetics["default"])();
  var supportedIntegrations = [_Integrations.DATADOG, _Integrations.MIXPANEL, _Integrations.SNOWFLAKE, _Integrations.INTERCOM];
  var integrations = {
    ADOBE_ANALYTICS: false,
    All: false,
    'AWS EventBridge': false,
    'AWS Lambda': false,
    'Google Analytics': false,
    Intercom: true,
    Marketo: false,
    Mixpanel: true,
    Salesforce: false,
    Snowflake: true,
    datadog: true
  };
  var isAutomationAccount = ['ci', 'test'].includes(environmentName);
  var baseData = _objectSpread(_objectSpread({
    appVersion: appVersion,
    product: 'studio',
    businessUnit: 'event',
    component: 'studio',
    persona: 'attendee',
    environmentName: environmentName,
    isCVIIUser: false,
    userId: userId,
    ddUserId: userId
  }, isAutomationAccount ? {
    userGroup: 'automation'
  } : {
    userGroup: 'unknown'
  }), {}, {
    broadcastId: broadcastId,
    teamId: teamId,
    eventId: eventId,
    webinarId: webinarId,
    externalUserId: externalUserId,
    result: 'success',
    destinations: supportedIntegrations,
    type: 'tracked'
  });
  try {
    if (isAutomationAccount) {
      throw new Error('This is an automation account');
    }
    if (isDDSynthetics) {
      throw new Error('This is a DD Synthetics Bot');
    }
    var logLevel = environmentName === 'dev' ? 'DEBUG' : null;
    rudderanalytics.load(rudderstackWriteKey, rudderstackDataPlaneUrl, {
      logLevel: logLevel,
      integrations: {
        All: true
      }
    });
    analyticsWeb.setRudderTyperOptions({
      analytics: rudderanalytics
    });
  } catch (e) {
    console.warn('Failed to load rudderstack: ', e);
  }
  return function (actionName, args) {
    var data = _objectSpread(_objectSpread({}, baseData), args);
    (0, _datadogLogger["default"])(supportedIntegrations, actionName, data);
    return isAutomationAccount || isDDSynthetics ? function () {} : analyticsWeb[actionName](data, {
      integrations: integrations
    });
  };
};